import styled from 'styled-components';

export const PermissionLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: var(--color-text-muted);
  padding: 20px 0 0;
`;
